import React, { Component, createRef } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'

import './search-input.scss'

@observer
class SearchInput extends Component {
    @observable searchStr = ''

    @observable showClear = false

    constructor(props) {
        super(props)
        makeObservable(this)
        this.searchRef = createRef()
    }

    componentDidMount() {
        const { autoFocus } = this.props

        if (autoFocus) {
            this.searchRef.current.focus()
        }
    }

    // onClick = () => {}

    clear = () => {
        const { onChange, onBlur } = this.props
        this.searchStr = ''
        this.showClear = false
        const call = (typeof onChange === 'function') ? onChange : onBlur
        call()
    }

    onChange = (e) => {
        const { onChange } = this.props

        this.searchStr = e.target.value
        this.showClear = this.searchStr !== ''

        if (typeof onChange === 'function') {
            onChange()
        }
    }

    onBlur = (e) => {
        const { onBlur } = this.props

        this.searchStr = e.target.value
        this.showClear = this.searchStr !== ''

        if (typeof onBlur === 'function') {
            onBlur()
        }
    }


    onKeyDown = (e) => {
        const { onBlur } = this.props
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            if (onBlur) {
                onBlur()
            }
        }
    }

    render() {
        const { label, style, cssClass } = this.props
        let searchClass = 'search'
        searchClass += cssClass ? ` ${cssClass}` : ''
        searchClass += label ? ' form-search' : ''
        return (
            <div className={searchClass} style={style}>
                {label && (
                    <label>
                        {label}
                    </label>
                )}
                <input
                    className="search-input"
                    type="text"
                    placeholder={!label ? 'Search' : ''}
                    ref={this.searchRef}
                    value={this.searchStr}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    onKeyDown={this.onKeyDown}
                />
                {!this.showClear
                    ? (
                        <i className="search-icon fa-regular fa-search" />
                    ) : (
                        <i
                            className={`close-icon ${label ? 'fa-sharp fa-light fa-circle-xmark' : 'fa-regular fa-x'}`}
                            onClick={this.clear}
                        />
                    )
                }
            </div>
        )
    }
}

export default SearchInput
